const ProductSkelton = () => {
  return (
    <div className="flex flex-col items-start w-full xs:w-[calc(50%-16px)] sm:w-[calc(33.33%-22px)] lg:w-[calc(25%-24px)] p-4 shadow-lg animate-pulse">
      <div className="w-full flex items-center justify-center h-[300px] bg-skelton"></div>
      <div className="flex flex-col min-h-[calc(100%-300px)]">
        <h4 className="h-[28px] text-lg bg-skelton mt-4 mb-4"></h4>
        <div className="inline-flex items-center w-[125px] h-[24px] bg-skelton"></div>
        <p className="w-[70px] h-[28px] text-lg bg-skelton mt-4 mb-6"></p>
        <div className="flex items-center gap-8 mt-auto mb-0">
          <button className="w-[128px] h-[56px] bg-skelton py-4 px-6 rounded-md"></button>
          <a className="w-[88px] h-[24px] bg-skelton underline"></a>
        </div>
      </div>
    </div>
  );
};

export default ProductSkelton;
